import React from "react";
import { Link } from "react-router-dom";

export function ErrorPage6() {
    return (
        <div style={styles.wrapper}>
            <div style={styles.container}>
                <h1 style={styles.title}>Ops!</h1>
                <p style={styles.description}>
                    Não encontramos essa página.
                    <br />
                    Talvez algo possa ter dado errado?
                </p>
                <Link to="/" style={styles.button}>
                    Voltar ao início
                </Link>
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#1aabe7",
    },
    container: {
        textAlign: "center",
        color: "#ffffff",
        padding: "2rem",
    },
    title: {
        fontSize: "10rem",
        fontWeight: "700",
        margin: "0 0 1rem",
        lineHeight: "1",
    },
    description: {
        fontSize: "2rem",
        fontWeight: "500",
        lineHeight: "1.5",
        marginBottom: "2.5rem",
    },
    button: {
        display: "inline-block",
        padding: "0.75rem 2rem",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        color: "#ffffff",
        borderRadius: "4px",
        textDecoration: "none",
        fontWeight: "500",
        fontSize: "1rem",
        border: "2px solid rgba(255, 255, 255, 0.6)",
    },
};
